import { render, staticRenderFns } from "./ConfigSystemRuleProperties.vue?vue&type=template&id=5f08326c&scoped=true&"
import script from "./ConfigSystemRuleProperties.vue?vue&type=script&lang=js&"
export * from "./ConfigSystemRuleProperties.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSystemRuleProperties.vue?vue&type=style&index=0&id=5f08326c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f08326c",
  null
  
)

export default component.exports